<template>

 <div v-if="calculating" class="row q-pa-md justify-center"><q-spinner color="secondary"/></div>
  <div v-else-if="!hasAnyData" class="q-pa-sm ">No coastal opportunity data were identified within the area of interest.</div>
  <div v-else id="coastalOpps" v-bind="attrs" class="q-pa-sm">
    <!-- <div v-if="coastalFieldValues.length" class="q-pa-sm text-caption text-left">
            <div class="row" v-for="field in coastalFieldValues" :key="field.key">
                <div class="col-12">{{ field.label }}:</div> 
                <div class="col-1"></div>
                <div class="col-11  text-wrap">{{ field.values }}</div>
            </div>
        </div> -->
    <div class="q-pa-sm text-caption text-left">The following show analyses that prioritize coastal habitats based on their importance to the species that use them throughout the year.</div>


    <q-expansion-item group="projs" dense label="SALTMARSH PROTECTION & RESTORATION OPPORTUNITIES" header-class="bg-grey-3 text-bold" class="proj-expander q-ml-md q-ma-xs">
        <div class="row q-pa-sm">
            <div row class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Resilient Coastal Sites
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['resilience'].model = !dataConsiderations['resilience'].model" aria-label="Estuary data help"/>
            <div class="q-pa-sm text-caption text-left">Migration space is important as sea-level rises and wetland habitats migrate inland. Highly resilient migration space  not only has the space to migrate but also the confirmed diversity and  condition that make them better candidates for conservation opportunities.</div>
            <div class="q-ml-md">
                <div v-if="totalMarshAcres !== null" class="q-pa-sm text-caption text-left">
                    <span class="text-bold">{{ totalMarshAcres?.toLocaleString() }}</span> ac of greater than average marsh migration space
                </div>
                <div v-if="coastalPriData" class="row items-center justiofy-center q-pa-sm">
                    <div class="col-11">
                        <StackedBar 
                            :data="priData['CR']" 
                            divName="cr" 
                            categoryProp="category" 
                            barName="cr" 
                            valueProp="value" 
                            class="q-mt-none" 
                            :xAxisTicks="false"
                            :categoryColors="crBarColors"
                            :topMargin="0"    
                            :leftMargin="0"  
                            :rectOutline="true"                                 
                        />
                    </div>
                    <div class="col-1 items-center self-center bordered q-mb-xs pointer" @click="mapStyleClick('CRMAX')"  :class="mapStyleAttr == 'CRMAX' ? 'mapActive' : ''">
                        <q-icon size="xs" v-if="mapStyleAttr != 'CRMAX'" name="chevron_right"></q-icon>
                        <q-icon color="white" v-else name="star" ></q-icon>
                        <q-tooltip>View this data in the map</q-tooltip>
                    </div>
                    <div class="col-12">
                        <div class="row text-caption" v-for="obj in priData['CR']" :key="obj.category">
                        <span class="q-ma-xs" :style="{'background-color': crBarColors[obj.category], 'width' :'10px'}"></span>
                        {{ obj.category[0] }}: {{ Math.round(obj.value) }}% ({{ obj.area?.toLocaleString() }} ac)
                        </div>
                    </div>
                </div>
        
            </div>
        </div>
        <div class="row q-pa-sm">
            <div class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Priority Marshes for Saltmarsh Sparrow
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['saltmarshSparrow'].model = !dataConsiderations['saltmarshSparrow'].model" aria-label="Saltmarsh Sparrow data help"/>
            <div class="q-pa-sm text-caption text-left">This analysis identifies priority salt marshes for restoration, enhancement, and management to support Saltmarsh Sparrow nesting habitat.</div>
            <div class="q-ml-md">
                <div v-if="priorityMarshAcres !== null" class="q-pl-sm text-caption text-left">
                    <span class="text-bold">{{ priorityMarshAcres?.toLocaleString() }}</span> ac of priority marshes (prioritized for ongoing restoration efforts)
                </div>
                <div v-if="referenceMarshAcres !== null" class="q-pl-sm text-caption text-left">
                    <span class="text-bold">{{ referenceMarshAcres?.toLocaleString() }}</span> ac of reference marshes (less degraded marshes)
                </div>
                <!-- <div v-if="honorableMentionMarshAcres !== null" class="q-pl-sm text-caption text-left">
                    <span class="text-bold">{{ honorableMentionMarshAcres?.toLocaleString() }}</span> ac of honorable mention marshes
                </div> -->
                <div v-if="coastalPriData" class="row items-center justiofy-center q-pa-sm">
                    <div class="col-11">
                        <StackedBar 
                            :data="priData['SALTMARSH_SPARROW']" 
                            divName="saltmarsh" 
                            categoryProp="category" 
                            barName="saltmarsh" 
                            valueProp="value" 
                            class="q-mt-none" 
                            :xAxisTicks="false"
                            :categoryColors="saltmarshColors"
                            :topMargin="0"    
                            :leftMargin="0"  
                            :rectOutline="true"                                 
                        />
                    </div>
                    <div class="col-12">
                        <div class="row  text-caption" v-for="obj in priData['SALTMARSH_SPARROW']" :key="obj.category">
                            <div class="col-10 row items-center no-wrap">
                                <span class="q-ma-xs" :style="{'background-color': saltmarshColors[obj.category], 'display': 'inline-block', 'width': '10px', 'height': '10px'}"></span>
                                <span>{{ obj.category }}: {{ Math.round(obj.value) }}% ({{ obj.area?.toLocaleString() }} ac)</span>
                            </div>
                            <div class="col-1"></div>
                            <div
                                v-if="saltmarshMapAttrs[obj.category]"
                                class="col-1 items-center self-center bordered pointer "
                                @click.stop="mapStyleClick(saltmarshMapAttrs[obj.category])"
                                :class="mapStyleAttr == saltmarshMapAttrs[obj.category] ? 'mapActive' : ''"
                            >
                                <q-icon size="xs" v-if="mapStyleAttr != saltmarshMapAttrs[obj.category]" name="chevron_right"></q-icon>
                                <q-icon color="white" size="xs" v-else name="star" ></q-icon>
                                <q-tooltip>View this data in the map</q-tooltip>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row q-pa-sm">
            <div class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Marsh Restoration Opportunities (2030 Chesapeake Bay)
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['chesBaySediment'].model = !dataConsiderations['chesBaySediment'].model" aria-label="Saltmarsh Sparrow data help"/>

            <div class="q-ml-md">
                <div v-if="combinedHighEffortAcres !== null" class="q-pl-sm q-pt-xs text-caption text-left">
                    <span class="text-bold">{{ combinedHighEffortAcres?.toLocaleString() }}</span> ac of high effort (in urgent need due to its condition)
                </div>
                <div v-if="combinedLowEffortAcres !== null" class="q-pl-sm q-pt-xs text-caption text-left">
                    <span class="text-bold">{{ combinedLowEffortAcres?.toLocaleString() }}</span> ac of low effort (important to address before problem gets bigger)
                </div>
                <div v-if="coastalPriData" class="col-12">
                    <div class="row items-center justiofy-center q-pa-sm">
                        <div class="col-11">
                            <StackedBar
                                :data="priData['HYDROLOGY_COMBINED']"
                                divName="hydrology_combined"
                                categoryProp="category"
                                barName="hydrology_combined"
                                valueProp="value"
                                class="q-mt-none"
                                :xAxisTicks="false"
                                :categoryColors="hydroBarColors"
                                :topMargin="0"
                                :leftMargin="0"
                                :rectOutline="true"
                            />
                        </div>
                        <div class="col-12">
                            <div class="row text-caption" v-for="obj in priData['HYDROLOGY_COMBINED']" :key="obj.category">
                                <div class="col-10 row items-center no-wrap">
                                        <span class="q-ma-xs" :style="{'background-color': hydroBarColors[obj.category], 'display': 'inline-block', 'width': '10px', 'height': '10px'}"></span>
                                    {{ obj.category }}: {{ Math.round(obj.value) }}% ({{ obj.area?.toLocaleString() }} ac)
                                </div>
                                <div class="col-1"></div>
                                <div
                                    v-if="obj.category === 'High'"
                                    class="col-1 items-center self-center bordered pointer"
                                    @click.stop="mapStyleClick('RunnelCombHighSqKM')"
                                    :class="mapStyleAttr == 'RunnelCombHighSqKM' ? 'mapActive' : ''"
                                >
                                    <q-icon size="xs" v-if="mapStyleAttr != 'RunnelCombHighSqKM'" name="chevron_right"></q-icon>
                                    <q-icon color="white" size="xs" v-else name="star" ></q-icon>
                                    <q-tooltip>View this data in the map</q-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </q-expansion-item>



    <q-expansion-item group="projs" dense label="CONNECTIVITY OPPORTUNITIES" header-class="bg-grey-3 text-bold" class="proj-expander q-ml-md q-ma-xs">
        <div class="row q-pa-sm">
            <div row class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Migratory stopover hotspots
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['migHotSpots'].model = !dataConsiderations['migHotSpots'].model" aria-label="Saltmarsh Sparrow data help"/>

            <div class="q-ml-md">
                <div v-if="migratoryHotspotAcres !== null" class="q-pl-sm q-pt-xs text-caption text-left">
                    <span class="text-bold">{{ migratoryHotspotAcres?.toLocaleString() }}</span> acres considered a stopover hotspot
                </div>
                <div v-if="coastalPriData" class="row items-center justiofy-center q-pa-sm">
                    <div class="col-11">
                        <StackedBar
                            :data="priData['MIGRATORY_HOTSPOT']"
                            divName="migratory_hotspot"
                            categoryProp="category"
                            barName="migratory_hotspot"
                            valueProp="value"
                            class="q-mt-none"
                            :xAxisTicks="false"
                            :categoryColors="migratoryBarColors"
                            :topMargin="0"
                            :leftMargin="0"
                            :rectOutline="true"
                        />
                    </div>
                    <div class="col-12">
                        <div class="row text-caption" v-for="obj in priData['MIGRATORY_HOTSPOT']" :key="obj.category">
                            <div class="col-10 row items-center no-wrap">
                                <span class="q-ma-xs" :style="{'background-color': migratoryBarColors[obj.category], 'display': 'inline-block', 'width': '10px', 'height': '10px'}"></span>
                                {{ obj.category }}: {{ Math.round(obj.value) }}% ({{ obj.area?.toLocaleString() }} ac)
                            </div>
                            <div class="col-1"></div>
                            <div
                                v-if="migratoryMapAttrs[obj.category]"
                                class="col-1 items-center self-center bordered pointer"
                                @click.stop="mapStyleClick(migratoryMapAttrs[obj.category])"
                                :class="mapStyleAttr == migratoryMapAttrs[obj.category] ? 'mapActive' : ''"
                            >
                                <q-icon size="xs" v-if="mapStyleAttr != migratoryMapAttrs[obj.category]" name="chevron_right"></q-icon>
                                <q-icon color="white" size="xs" v-else name="star" ></q-icon>
                                <q-tooltip>View this data in the map</q-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row q-pa-sm">
            <div row class="q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Tidal crossings in need of replacement (NH)
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['nhTidal'].model = !dataConsiderations['nhTidal'].model" aria-label="Saltmarsh Sparrow data help"/>

            <div class="q-pl-md col-12">        
                <div v-if="coastalPriData" class="items-center justify-center q-pa-sm">
                    <div class="row text-caption" v-for="obj in priData['TIDAL_CROSSINGS']" :key="obj.category">
                        <div class="col-10 row items-center no-wrap">
                            <span class="q-ma-xs" :style="{'background-color': tidalCrossingBarColors[obj.category], 'display': 'inline-block', 'width': '10px', 'height': '10px'}"></span>
                            {{ obj.category }}:&nbsp;<span v-if="obj.category !== 'None'">{{ obj.cnt?.toLocaleString() }} crossings</span>
                        </div>
                        <div class="col-1"></div>
                        <div
                            v-if="obj.category === 'High Priority'"
                            class="col-1 items-center self-center bordered pointer"
                            @click.stop="mapStyleClick('TCHighCnt')"
                            :class="mapStyleAttr == 'TCHighCnt' ? 'mapActive' : ''"
                        >
                            <q-icon size="xs" v-if="mapStyleAttr != 'TCHighCnt'" name="chevron_right"></q-icon>
                            <q-icon color="white" size="xs" v-else name="star" ></q-icon>
                            <q-tooltip>View this data in the map</q-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </q-expansion-item>



    <q-expansion-item group="projs" dense label="CONSERVATION OPPORTUNITIES FOR ESTUARINE AND DIADROMOUS SPECIES" header-class="bg-grey-3 text-bold" class="proj-expander q-ml-md q-ma-xs">
        <div class="row q-pa-sm">
            <div row class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Habitat value for estuarine species
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['estuPriorities'].model = !dataConsiderations['estuPriorities'].model" aria-label="Estuarine priority data help"/>
            <div class="q-pl-md"> 
                <div class="q-pa-sm text-caption text-left">Values 60% or higher are considered high valued habitats for estuarine species and therefore potential opportunities for conservation. Values between 30 and 60% may signal potential opportunities for restoration. </div>
                <div v-if="coastalPriData" class="row items-center justiofy-center q-pa-sm">
                    <div class="col-11">
                        <StackedBar 
                            :data="priData['FISH_EST_3CLS']" 
                            divName="estu" 
                            categoryProp="category" 
                            barName="estu" 
                            valueProp="value" 
                            class="q-mt-none" 
                            :xAxisTicks="false"
                            :categoryColors="estuaryGroupColors"
                            :topMargin="0"    
                            :leftMargin="0"  
                            :rectOutline="true"                                 
                        />
                    </div>
                    <div class="col-12">
                        <div class="row text-caption items-center" v-for="obj in priData['FISH_EST_3CLS']" :key="obj.category">
                            <div class="col-11 row items-center">
                                <span class="q-ma-xs" :style="{ 'background-color': estuaryGroupColors[obj.category], 'width' :'10px', 'height': '10px', 'display': 'inline-block' }"></span>
                                {{ obj.category }}: {{  Math.round(obj.value) }}%
                            </div>
                            <div class="col-1 items-center self-center bordered q-mb-xs pointer"
                                v-if="obj.category === 'High'"
                                @click="mapStyleClick('FISH_EST_HIGH')"
                                :class="mapStyleAttr == 'FISH_EST_HIGH' ? 'mapActive' : ''">
                                <q-icon size="xs" v-if="mapStyleAttr != 'FISH_EST_HIGH'" name="chevron_right"></q-icon>
                                <q-icon color="white" v-else name="star" ></q-icon>
                                <q-tooltip>View this data in the map</q-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
        <div class="row q-pa-sm q-mt-md">
            <div row class="row q-pl-sm underline  text-uppercase text-h7 text-weight-medium">
                Habitat value for diadromous fish
            </div>
            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations['diadromous'].model = !dataConsiderations['diadromous'].model" aria-label="Diadromous fish data help"/>
            <!-- <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['diad'].model = !infoDialogs['diad'].model" aria-label="Diadromous fish data help"/> -->
            <div class="q-pl-md"> 
                <div class="q-pa-sm text-caption text-left">Values 60% or higher are considered high valued habitats for diadromous fish and therefore potential opportunities for conservation. Values between 30 and 60% may signal potential opportunities for restoration. View the map to show the majority class within each cell. </div>
                <div v-if="coastalPriData" class="row items-center justiofy-center q-pa-sm">
                    <div class="col-11">
                        <StackedBar 
                            :data="priData['FISH_DIA_3CLS']" 
                            divName="diad" 
                            categoryProp="category" 
                            barName="diad" 
                            valueProp="value" 
                            class="q-mt-none" 
                            :xAxisTicks="false"
                            :categoryColors="estuaryGroupColors"
                            :topMargin="0"    
                            :leftMargin="0"  
                            :rectOutline="true"                                 
                        />
                    </div>
                    <div class="col-12">
                        <div class="row text-caption items-center" v-for="obj in priData['FISH_DIA_3CLS']" :key="obj.category">
                            <div class="col-11 row items-center">
                                <span class="q-ma-xs" :style="{ 'background-color': estuaryGroupColors[obj.category], 'width' :'10px', 'height': '10px', 'display': 'inline-block' }"></span>
                                {{ obj.category }}: {{  Math.round(obj.value) }}%
                            </div>
                            <div class="col-1 items-center self-center bordered q-mb-xs pointer"
                                v-if="obj.category === 'High'"
                                @click="mapStyleClick('FISH_DIA_HIGH')"
                                :class="mapStyleAttr == 'FISH_DIA_HIGH' ? 'mapActive' : ''">
                                <q-icon size="xs" v-if="mapStyleAttr != 'FISH_DIA_HIGH'" name="chevron_right"></q-icon>
                                <q-icon color="white" v-else name="star" ></q-icon>
                                <q-tooltip>View this data in the map</q-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </q-expansion-item>


  </div>
          
  <div v-for="(infoObj, name) in infoDialogs" :key="name" >
      <q-dialog v-model="infoObj.model">
          <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
      </q-dialog>
  </div>
  <div v-for="(infoObj, name) in dataConsiderations" :key="name" >
      <q-dialog v-model="infoObj.model">
          <q-card>
          <q-card-section>
              <CoastalDataConsiderations :groupsToShow="name" />
          </q-card-section>
          <q-card-actions align="right">
              <q-btn flat label="OK" color="primary" @click="infoObj.model = false" />
          </q-card-actions>
          </q-card>
      </q-dialog>
  </div>
</template>
<script setup lang="ts">
// @ts-nocheck
import { toRefs, ref, computed, watch, onMounted, useAttrs } from "vue";
import { useRouter } from 'vue-router';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
import StackedBar from "./StackedBar.vue";
import { AllCodes } from "../assets/SppCodesToNames.json"
import { opps_fieldnames } from "../assets/opps_fieldnames.json"
import { stops } from "../assets/ColorStops.json"
import SpSpotSelect from "./SpSpotSelect.vue";
import CoastalDataConsiderations from "./CoastalDataConsiderations.vue";

const router = useRouter();
const {  map, activeSpSpotlight, loadDataByID, clearMapStyle, styleMap, setLegend, mapStyleInfo,  activeLayerID, processedData, setProcessedData } = useMapItems()
const { arrayFindObjectByProp,  countOccurrences, sumArray } = useHelpers();
const attrs = useAttrs();

const calculating = ref(true)

const props = defineProps({
    data: { type: Object, required: true },
    version: { type: Number, required: true },

})
const { data, version  } = toRefs(props)

type CoastalCellValue = number | string | null | undefined
type CoastalPriorityCell = Record<string, CoastalCellValue>
type FishAttr = "FISH_DIA" | "FISH_EST"
type PriBarDatum = {
  category: string | string[]
  value?: number
  area?: number
  cnt?:number
}

const mapStyleAttr = computed(() => {
  const current = mapStyleInfo.value as { attr?: string } | undefined
    if (current?.attr === "MM_GtAvg_Sum") return "CRMAX"
        if (current?.attr === "FISH_EST") return "FISH_EST_HIGH"
        if (current?.attr === "FISH_DIA") return "FISH_DIA_HIGH"
    return typeof current?.attr === "string" ? current.attr : ""
})

const totalMarshAcres = computed(() => {
  const crEntries = priData.value?.['CR']
  if (!crEntries) return null
  const marshNames = [
    "Far above average marsh migration space",
    "Above average marsh migration space",
    "Slightly above average marsh migration space"
  ]
  const total = crEntries
    .filter((d: PriBarDatum) => marshNames.includes((d.category as string[])[0]))
    .reduce((sum: number, d: PriBarDatum) => sum + (d.area ?? 0), 0)
  return total > 0 ? total : null
})

const priorityMarshAcres = computed(() => {
  const saltmarshData = priData.value?.['SALTMARSH_SPARROW']
  if (!saltmarshData) return null
  const item = saltmarshData.find((d: PriBarDatum) => d.category === 'Priority Marsh for Saltmarsh Sparrow')
  return item?.area ?? null
})

const referenceMarshAcres = computed(() => {
  const saltmarshData = priData.value?.['SALTMARSH_SPARROW']
  if (!saltmarshData) return null
  const item = saltmarshData.find((d: PriBarDatum) => d.category === 'Reference Marsh for Saltmarsh Sparrow')
  return item?.area ?? null
})

const honorableMentionMarshAcres = computed(() => {
  const saltmarshData = priData.value?.['SALTMARSH_SPARROW']
  if (!saltmarshData) return null
  const item = saltmarshData.find((d: PriBarDatum) => d.category === 'Hon. Mention Marsh for Saltmarsh Sparrow')
  return item?.area ?? null
})

const migratoryHotspotAcres = computed(() => {
  const migData = priData.value?.['MIGRATORY_HOTSPOT']
  if (!migData) return null
  const total = migData
    .filter((d: PriBarDatum) => d.category !== 'No data')
    .reduce((sum: number, d: PriBarDatum) => sum + (d.area ?? 0), 0)
  return total > 0 ? total : null
})

const combinedHighEffortAcres = computed(() => {
    const hydroData = priData.value?.['HYDROLOGY_COMBINED']
    if (!hydroData) return null

    const total = hydroData.find((d: PriBarDatum) => d.category === 'High')?.area ?? 0
    return total > 0 ? total : null
})

const combinedLowEffortAcres = computed(() => {
    const hydroData = priData.value?.['HYDROLOGY_COMBINED']
    if (!hydroData) return null

    const total = hydroData.find((d: PriBarDatum) => d.category === 'Low')?.area ?? 0
    return total > 0 ? total : null
})

const tidalCrossingsTotalCount = computed(() => {
    const tidalData = priData.value?.['TIDAL_CROSSINGS']
    if (!tidalData) return null
    const high = tidalData.find((d: PriBarDatum) => d.category === 'High Priority')?.cnt ?? 0
    const moderate = tidalData.find((d: PriBarDatum) => d.category === 'Moderate Priority')?.cnt ?? 0
    const total = high + moderate
    return total > 0 ? total : null
})

const coastalPriData =  computed<CoastalPriorityCell[] | null>(() =>{
    // console.log(data.value )
    const coastalPriorities = (data.value as Record<string, unknown>)?.["COASTAL_PRIORITIES"]
    if (Array.isArray(coastalPriorities) && coastalPriorities.length > 0){
        return coastalPriorities as CoastalPriorityCell[]
    }
    else{ return null}
})

const coastalFieldValues = computed(() => {
    console.log(coastalPriData.value)
    const coastalData = coastalPriData.value
    if (!coastalData) {
        return []
    }

    return Object.entries(opps_fieldnames)
        .map(([fieldName, displayName]) => ({
            key: fieldName,
            label: displayName,
            values: coastalData.map((cell: CoastalPriorityCell) => cell[fieldName])
        }))
        .filter((entry) => entry.values.some((value: CoastalCellValue) => value !== undefined && value !== null))
})


const priData = computed(() =>{
    const versionKey = version.value
    const processedDataByVersion = processedData.value as Record<number, Record<string, any>>
  if (
            !processedDataByVersion[versionKey] || 
            processedDataByVersion[versionKey]['COASTAL_PRIORITIES'] === undefined || 
            processedDataByVersion[versionKey]['COASTAL_PRIORITIES']['barData']===undefined 
    ){
            const attrs: FishAttr[] = ["FISH_DIA", "FISH_EST"]
            const resultVals: Record<FishAttr, number[]> = {
                FISH_DIA: [],
                FISH_EST: []
            }
            const results: Record<string, PriBarDatum[]> = {
                FISH_DIA: [],
                FISH_EST: []
            }

            const crData: Record<string, number[]> = {}
            const finCRData: PriBarDatum[] = []
            const totalArea: number[] = []
            const anyCR: number[] = []

            const saltmarshKeys = ["PriorityMarshes", "ReferenceMarshes", "HonorableMentionMarshes"]
            const saltmarshFieldNames: Record<string, string> = {
                "PriorityMarshes": "Priority Marsh for Saltmarsh Sparrow",
                "ReferenceMarshes": "Reference Marsh for Saltmarsh Sparrow",
                "HonorableMentionMarshes": "Hon. Mention Salt Marsh for Saltmarsh Sparrow"
            }
            const saltmarshAreaData: Record<string, number[]> = {}
            const finSaltmarshData: PriBarDatum[] = []
            for (const key of saltmarshKeys) {
                saltmarshAreaData[key] = []
            }

            const migratoryKeys = ["AutumHotSpot", "SpringHotSpot"]
            const migratoryAreaData: Record<string, number[]> = {}
            const finMigratoryData: PriBarDatum[] = []
            for (const key of migratoryKeys) migratoryAreaData[key] = []

            const tidalKeys = ["TCLowCnt", "TCMedCnt", "TCHighCnt"]
            const tidalCountsByClass: Record<string, number> = {
                "Low Priority": 0,
                "Moderate Priority": 0,
                "High Priority": 0
            }
            const tidalAreaByClass: Record<string, number> = {
                "Low Priority": 0,
                "Moderate Priority": 0,
                "High Priority": 0,
                "None": 0
            }
            const finTidalData: PriBarDatum[] = []

            const hydroCombinedKeys = ["RunnelCombHighSqKM", "RunnelCombMedSqKM", "RunnelCombLowSqKM"]
            const hydroCombinedAreaData: Record<string, number[]> = {}
            const finHydroCombinedData: PriBarDatum[] = []
            for (const key of hydroCombinedKeys) hydroCombinedAreaData[key] = []

      //  create arrays for each resilience  class for bars
      for (const [key, value] of Object.entries(stopNames['CRMAX'])) { // class names for coastal res
        crData[key] = []
      }

      if (coastalPriData.value){
                coastalPriData.value.forEach((cell: CoastalPriorityCell) =>{
                    totalArea.push(Number(cell['AREA_SQM']) || 0)
          attrs.forEach((attr) =>{
                            resultVals[attr].push(Number(cell[attr]) || 0)
          })

          // get the values for all of the coastal resilience classes
          for (const [key, value] of Object.entries(stopNames['CRMAX'])) {
            const cellValue = Number(cell[key])
            if (Number.isFinite(cellValue) ){
                crData[key].push(cellValue)
                anyCR.push(cellValue)
            }
          }
          // get saltmarsh sparrow area values
          for (const key of saltmarshKeys) {
            const cellValue = Number(cell[key])
            if (Number.isFinite(cellValue)) {
                saltmarshAreaData[key].push(cellValue)
            }
          }
          // migratory hotspot area values
          for (const key of migratoryKeys) {
            const cellValue = Number(cell[key])
            if (Number.isFinite(cellValue)) migratoryAreaData[key].push(cellValue)
          }
                    // tidal crossings values and mutually exclusive AOI class area
                    const lowCount = Number(cell['TCLowCnt'])
                    const medCount = Number(cell['TCMedCnt'])
                    const highCount = Number(cell['TCHighCnt'])
                    const low = Number.isFinite(lowCount) ? lowCount : 0
                    const med = Number.isFinite(medCount) ? medCount : 0
                    const high = Number.isFinite(highCount) ? highCount : 0
                    tidalCountsByClass['Low Priority'] += low
                    tidalCountsByClass['Moderate Priority'] += med
                    tidalCountsByClass['High Priority'] += high

                    const cellAreaSqKm = (Number(cell['AREA_SQM']) || 0) / 1e6
                    if (high > 0) tidalAreaByClass['High Priority'] += cellAreaSqKm
                    else if (med > 0) tidalAreaByClass['Moderate Priority'] += cellAreaSqKm
                    else if (low > 0) tidalAreaByClass['Low Priority'] += cellAreaSqKm
                    else tidalAreaByClass['None'] += cellAreaSqKm
                    // combined hydrology + sediment restoration area values
                    for (const key of hydroCombinedKeys) {
            const cellValue = Number(cell[key])
                        if (Number.isFinite(cellValue)) hydroCombinedAreaData[key].push(cellValue)
          }
        })

        // get the # of cells -- used to calc % 
        const numCells = (resultVals['FISH_DIA'].length); // same for all
        const totalAreaSum = sumArray(totalArea)

        const SQM_TO_ACRES = 0.000247105
        const marshKeys = ["CR11", "CR10", "CR9"]
        const nonMarshKeys = ["CR12", "CR13", "CR14"]

        // push marsh migration space classes individually
        for (const key of marshKeys) {
          const areaM2 = sumArray(crData[key])
          finCRData.push({
            category: [stopNames['CRMAX'][key]],
            value: Math.round((areaM2 / totalAreaSum) * 100 * 10) / 10,
            area: Math.round(areaM2 * SQM_TO_ACRES)
          })
        }

        // combine non-marsh CR classes + uncategorized area into one category
        const nonMarshCRArea = nonMarshKeys.reduce((sum: number, key: string) => sum + sumArray(crData[key]), 0)
        const totalCRArea = Object.values(crData).reduce((sum: number, arr: number[]) => sum + sumArray(arr), 0)
        const nonMarshTotal = nonMarshCRArea + Math.max(0, totalAreaSum - totalCRArea)
        finCRData.push({
          category: ["Non marsh migration space"],
          value: Math.round((nonMarshTotal / totalAreaSum) * 100 * 10) / 10,
          area: Math.round(nonMarshTotal * SQM_TO_ACRES)
        })
        results['CR'] = finCRData

        // daidromous & estuarine
        attrs.forEach((attr) =>{
            // loop through the categories and count the occurances of each
            for (const [code, name] of Object.entries(stopNames[attr])) {
                results[attr].push({
                    category : name,
                    value: Math.round((countOccurrences(resultVals[attr], parseInt(code))/ numCells *100) *10 /10)
                }) 
            }
        })

        const estuaryGroups = [
            { category: "High", values: [60, 70, 80] },
            { category: "Medium", values: [30, 40, 50] },
            { category: "Low", values: [0, 10, 20] }            
        ]
        const validEstuaryCells = resultVals['FISH_EST'].filter((v) => v >= 0)
        const estuaryDenominator = validEstuaryCells.length || 1
        results['FISH_EST_3CLS'] = estuaryGroups.map((group) => {
            const count = validEstuaryCells.filter((v) => group.values.includes(v)).length
            return {
                category: group.category,
                value: Math.round((count / estuaryDenominator) * 1000) / 10
            }
        })

        const diadromousGroups = [
            { category: "High", values: [60, 70, 80] },
            { category: "Medium", values: [30, 40, 50] },
            { category: "Low", values: [0, 10, 20] }
        ]
        const validDiadromousCells = resultVals['FISH_DIA'].filter((v) => v >= 0)
        const diadromousDenominator = validDiadromousCells.length || 1
        results['FISH_DIA_3CLS'] = diadromousGroups.map((group) => {
            const count = validDiadromousCells.filter((v) => group.values.includes(v)).length
            return {
                category: group.category,
                value: Math.round((count / diadromousDenominator) * 1000) / 10
            }
        })


       

        // saltmarsh sparrow priorities (field values are in sq km)
        const SQKM_TO_ACRES = 247.105
        const totalAreaSqKm = totalAreaSum / 1e6
        const totalSaltmarshArea = saltmarshKeys.reduce((sum: number, key: string) => sum + sumArray(saltmarshAreaData[key]), 0)
        for (const key of saltmarshKeys) {
            const areaSqKm = sumArray(saltmarshAreaData[key])
            finSaltmarshData.push({
                category: saltmarshFieldNames[key],
                value: totalAreaSqKm > 0 ? Math.round((areaSqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
                area: Math.round(areaSqKm * SQKM_TO_ACRES)
            })
        }
        const noSaltmarshSqKm = Math.max(0, totalAreaSqKm - totalSaltmarshArea)
        finSaltmarshData.push({
            category: "No saltmarsh data",
            value: totalAreaSqKm > 0 ? Math.round((noSaltmarshSqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
            area: Math.round(noSaltmarshSqKm * SQKM_TO_ACRES)
        })
        results['SALTMARSH_SPARROW'] = finSaltmarshData


        // migratory stopover hotspots (field values are in sq km)
        const migratoryLabels: Record<string, string> = {
            "AutumHotSpot": "Autumn Stopover Hotspot",
            "SpringHotSpot": "Spring Stopover Hotspot"
        }
        const totalMigratoryArea = migratoryKeys.reduce((sum: number, key: string) => sum + sumArray(migratoryAreaData[key]), 0)
        for (const key of migratoryKeys) {
            const areaSqKm = sumArray(migratoryAreaData[key])
            finMigratoryData.push({
                category: migratoryLabels[key],
                value: totalAreaSqKm > 0 ? Math.round((areaSqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
                area: Math.round(areaSqKm * SQKM_TO_ACRES)
            })
        }
        const noMigratorySqKm = Math.max(0, totalAreaSqKm - totalMigratoryArea)
        finMigratoryData.push({
            category: "No data",
            value: totalAreaSqKm > 0 ? Math.round((noMigratorySqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
            area: Math.round(noMigratorySqKm * SQKM_TO_ACRES)
        })
        results['MIGRATORY_HOTSPOT'] = finMigratoryData

        // tidal crossings in need of replacement
        const tidalCategoryOrder = ["High Priority", "Moderate Priority", "Low Priority", "None"]
        for (const category of tidalCategoryOrder) {
            finTidalData.push({
                category,
                cnt: category === 'None' ? 0 : Math.round(tidalCountsByClass[category] || 0)
            })
        }
        results['TIDAL_CROSSINGS'] = finTidalData

        // combined hydrology + sediment priorities (field values are in sq km)
        const hydroCombinedLabels: Record<string, string> = {
            "RunnelCombHighSqKM": "High",
            "RunnelCombMedSqKM": "Medium",
            "RunnelCombLowSqKM": "Low"
        }
        const totalHydroCombinedArea = hydroCombinedKeys.reduce((sum: number, key: string) => sum + sumArray(hydroCombinedAreaData[key]), 0)
        for (const key of hydroCombinedKeys) {
            const areaSqKm = sumArray(hydroCombinedAreaData[key])
            finHydroCombinedData.push({
                category: hydroCombinedLabels[key],
                value: totalAreaSqKm > 0 ? Math.round((areaSqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
                area: Math.round(areaSqKm * SQKM_TO_ACRES)
            })
        }
        const noHydroCombinedSqKm = Math.max(0, totalAreaSqKm - totalHydroCombinedArea)
        finHydroCombinedData.push({
            category: "No data",
            value: totalAreaSqKm > 0 ? Math.round((noHydroCombinedSqKm / totalAreaSqKm) * 100 * 10) / 10 : 0,
            area: Math.round(noHydroCombinedSqKm * SQKM_TO_ACRES)
        })
        results['HYDROLOGY_COMBINED'] = finHydroCombinedData

        ;(setProcessedData as (...args: any[]) => void)(versionKey, "COASTAL_PRIORITIES", null, null, results)

        return results
      }
      else{
          return null
      }
      

    }
    else{
    //   console.log("loading saved processed bar chart results")
        return processedDataByVersion[versionKey]['COASTAL_PRIORITIES']['barData']
    }
  

})

const fishColors: Record<string, string> = {
    "No Data" : "#aeaeae",
    "0 (Low)": "#4575b4",
    "10": "#74add1",
    "20": "#abd9e9",
    "30": "#e0f3f8",
    "40": "#ffffbf",
    "50": "#fee090",
    "60": "#fdae61",
    "70": "#f46d43",
    "80 (High)": "#d73027"
}

const estuaryGroupColors: Record<string, string> = {
    "Low": "#A9EBCD",
    "Medium": "#49AB7E",
    "High": "#016637"
}

const stopNames: Record<string, Record<string, string>> = {
    "FISH_DIA" : {
        "-9": "No Data",
        "0": "0 (Low)",
        "10": "10",
        "20": "20",
        "30": "30",
        "40": "40",
        "50": "50",
        "60": "60",
        "70": "70",
        "80": "80 (High)"
    },
    "FISH_EST" : {
        "-9": "No Data",
        "0": "0 (Low)",
        "10": "10",
        "20": "20",
        "30": "30",
        "40": "40",
        "50": "50",
        "60": "60",
        "70": "70",
        "80": "80 (High)"
    },
    "CRMAX": {
        "CR11": "Far above average marsh migration space",
        "CR10": "Above average marsh migration space",
        "CR9": "Slightly above average marsh migration space",
        "CR12": "Vulnerable tidal complex",
        "CR13": "Above average resilience tidal complex",
        "CR14": "Sea level rise area"
    }
} 



const crBarColors: Record<string, string> = {
    "Far above average marsh migration space": "#054d73",
    "Above average marsh migration space": "#2b8cbe",
    "Slightly above average marsh migration space": "#8ac9eb",
    "Non marsh migration space": "#b5b5b5"
}

const crGradientStopsSqM: [number, string][] = [
    // [1, "#deebf7"],
    // [500000, "#bdd7e7"],
    // [1000000, "#6baed6"],
    // [2000000, "#3182bd"],
    // [2500000, "#08519c"]

    [1, "#dadaeb"],
    [500000, "#bcbddc"],
    [1000000, "#807dba"],
    [2000000, "#6a51a3"],
    [2500000, "#4a1486"]
]

const crGradientLegendSqM = [
    // ["2.5 sq km", "#08519c"],
    // ["2 sq km", "#3182bd"],
    // ["1 sq km", "#6baed6"],
    // ["0.5 sq km", "#bdd7e7"],
    // ["> 0 sq km", "#deebf7"]
  ["2.5 sq km", "#4a1486"],
  ["2 sq km", "#6a51a3"],
  ["1 sq km", "#807dba"],
  ["0.5 sq km", "#bcbddc"],
  ["> 0 sq km", "#dadaeb"]
]

const saltmarshGradientStopsSqKm: [number, string][] = [
    // [0.000001, "#deebf7"],
    // [0.5, "#bdd7e7"],
    // [1, "#6baed6"],
    // [2, "#3182bd"],
    // [2.5, "#08519c"]

    [0.000001, "#dadaeb"],
    [0.5, "#bcbddc"],
    [1, "#807dba"],
    [2, "#6a51a3"],
    [2.5, "#4a1486"]
]

const saltmarshGradientLegendSqKm = [
    // ["2.5 sq km", "#08519c"],
    // ["2 sq km", "#3182bd"],
    // ["1 sq km", "#6baed6"],
    // ["0.5 sq km", "#bdd7e7"],
    // ["> 0 sq km", "#deebf7"]
  ["2.5 sq km", "#4a1486"],
  ["2 sq km", "#6a51a3"],
  ["1 sq km", "#807dba"],
  ["0.5 sq km", "#bcbddc"],
  ["> 0 sq km", "#dadaeb"]
]

const getCRGradientExpression = () => [
    "case",
    ["<=", ["coalesce", ["get", "MM_GtAvg_Sum"], 0], 0],
    "#aeaeaeCC",
    [
        "interpolate",
        ["linear"],
        ["get", "MM_GtAvg_Sum"],
        ...crGradientStopsSqM.flat()
    ]
]

const saltmarshColors: Record<string, string> = {
    "Priority Marsh for Saltmarsh Sparrow": "#13f21f",
    "Reference Marsh for Saltmarsh Sparrow": "#94e397",
    "Hon. Mention Salt Marsh for Saltmarsh Sparrow": "#e1f7e2",
    "No saltmarsh data": "#b5b5b5"
}

const saltmarshMapAttrs: Record<string, keyof typeof layerPrettyNames> = {
    "Priority Marsh for Saltmarsh Sparrow": "PriorityMarshes",
    "Reference Marsh for Saltmarsh Sparrow": "ReferenceMarshes"
}

const migratoryBarColors: Record<string, string> = {
    "Autumn Stopover Hotspot": "#d95f02",
    "Spring Stopover Hotspot": "#1b9e77",
    "No data": "#b5b5b5"
}

const migratoryMapAttrs: Record<string, keyof typeof layerPrettyNames> = {
    "Autumn Stopover Hotspot": "AutumHotSpot",
    "Spring Stopover Hotspot": "SpringHotSpot"
}

const tidalCrossingBarColors: Record<string, string> = {
    "Low Priority": "#A9EBCD",
    "Moderate Priority": "#49AB7E",
    "High Priority": "#016637",
    "None": "#b5b5b5"
}

const hydroBarColors: Record<string, string> = {
    "High": "#016637",
    "Medium": "#49AB7E",
    "Low": "#A9EBCD",
    "No data": "#b5b5b5"
}

const tidalHighStops: [number, string][] = [
    // [1, "#deebf7"],
    // [2, "#9ecae1"],
    // [3, "#6baed6"],
    // [5, "#2171b5"]

    [1, "#bcbddc"],
    [2, "#807dba"],
    [3, "#6a51a3"],
    [5, "#4a1486"]
]

const tidalHighLegend = [
    // ["5+ crossings", "#2171b5"],
    // ["3 crossings", "#6baed6"],
    // ["2 crossings", "#9ecae1"],
    // ["1 crossing", "#deebf7"],
    // ["0 crossings", "#aeaeaeCC"]
    ["5+ crossings", "#4a1486"],
    ["3 crossings", "#6a51a3"],
    ["2 crossings", "#807dba"],
    ["1 crossing", "#bcbddc"],
    ["0 crossings", "dadaebCC"]

]

const getTidalHighExpression = () => [
    "case",
    ["<=", ["coalesce", ["get", "TCHighCnt"], 0], 0],
    "#aeaeaeCC",
    [
        "interpolate",
        ["linear"],
        ["get", "TCHighCnt"],
        ...tidalHighStops.flat()
    ]
]

const getContinuousBlueExpression = (field: string) => [
    "case",
    ["<=", ["coalesce", ["get", field], 0], 0],
    "#aeaeaeCC",
    [
        "interpolate",
        ["linear"],
        ["get", field],
        ...saltmarshGradientStopsSqKm.flat()
    ]
]

const getEstuaryHighExpression = () => [
    "case",
    ["any", ["==", ["get", "FISH_EST"], 60], ["==", ["get", "FISH_EST"], 70], ["==", ["get", "FISH_EST"], 80]],
    "#d73027",
    "#aeaeaeCC"
]

const getDiadromousHighExpression = () => [
    "case",
    ["any", ["==", ["get", "FISH_DIA"], 60], ["==", ["get", "FISH_DIA"], 70], ["==", ["get", "FISH_DIA"], 80]],
    "#d73027",
    "#aeaeaeCC"
]

const mapStyleClick = (attr: keyof typeof layerPrettyNames, type='categorical') =>{    
    const lyrID = activeLayerID.value

    if (attr === 'CRMAX') {
        ;(styleMap as (...args: any[]) => void)(lyrID, 'MM_GtAvg_Sum', 'expression', getCRGradientExpression())
        ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', crGradientLegendSqM)
        return
    }

    if (attr === 'ReferenceMarshes' || attr === 'PriorityMarshes' || attr === 'RunnelCombHighSqKM' || attr === 'AutumHotSpot' || attr === 'SpringHotSpot') {
        ;(styleMap as (...args: any[]) => void)(lyrID, attr, 'expression', getContinuousBlueExpression(attr))
        ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', saltmarshGradientLegendSqKm)
        return
    }

    if (attr === 'TCHighCnt') {
        ;(styleMap as (...args: any[]) => void)(lyrID, attr, 'expression', getTidalHighExpression())
        ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', tidalHighLegend)
        return
    }

    if (attr === 'FISH_EST_HIGH') {
        ;(styleMap as (...args: any[]) => void)(lyrID, 'FISH_EST', 'expression', getEstuaryHighExpression())
        ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', [["High", "#d73027"], ["Other values", "#aeaeaeCC"]])
        return
    }

    if (attr === 'FISH_DIA_HIGH') {
        ;(styleMap as (...args: any[]) => void)(lyrID, 'FISH_DIA', 'expression', getDiadromousHighExpression())
        ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', [["High", "#d73027"], ["Other values", "#aeaeaeCC"]])
        return
    }

    const valueNames = stopNames[attr] ?? {}
    const stopValues = (stops as Record<string, (string | number)[][]>)[attr] ?? []
    ;(styleMap as (...args: any[]) => void)(lyrID, attr, type, stopValues, valueNames)
    ;(setLegend as (...args: any[]) => void)(layerPrettyNames[attr] + ' ', stopValues, valueNames)
}


const layerPrettyNames = {
    "FISH_DIA" : "ACFHP Diadromous Fish Priorities",
    "FISH_DIA_HIGH": "ACFHP Diadromous Fish Priorities (High)",
    "FISH_EST" : "ACFHP Estuarine Priorities",
    "FISH_EST_HIGH": "ACFHP Estuarine Priorities (High)",
    "ReferenceMarshes": "Reference Salt Marsh for Saltmarsh Sparrow",
    "PriorityMarshes": "Priority Salt Marsh for Saltmarsh Sparrow",
    "RunnelCombHighSqKM": "Hydrology + Sediment Combined (High)",
    "AutumHotSpot": "Autumn Stopover Hotspot",
    "SpringHotSpot": "Spring Stopover Hotspot",
    "TCHighCnt": "High Priority Tidal Crossings",
    "SEDIM" : "Sediment",
    "HARDB" : "Hard bottom",
    "SLOPE" : "Slope",
    "CRMAX" : "Greater than Avg Marsh Migration Space"
}

const dataConsiderations = ref({
    diadromous : {
        model:false
    },
    resilience: {
        model:false
    },
    estuPriorities :{
        model:false
    },
    saltmarshSparrow: {
        model:false
    },
    chesBaySediment:{
        model:false
    },
    migHotSpots:{
        model: false
    },
    nhTidal :{
        model: false
    }
})
const infoDialogs = ref({
    diad: {
        pName: "Diadromous Fish Priorities",
        model: false,
        text: "This data originates from Atlantic Coastal Fish Habitat Partnership's Fish Mapping and Prioritzation Analysis (Martin et al. 2020). This study included both a Diadromous and Estuarine fish analyses. "
    },
    estu: {
        pName: "Estuarine Priorities",
        model: false,
        text: "This data originates from Atlantic Coastal Fish Habitat Partnership's Fish Mapping and Prioritzation Analysis (Martin et al. 2020). This study included both a Diadromous and Estuarine fish analyses. "
    },
    cr: {
        pName: "Coastal Resilience",
        model: false,
        text: "Data originates from the Resilient Coastal Sites Analysis by The Nature Conservancy (Anderson & Barnett, 2017)."
    },
   
})

onMounted(() => {
  if (activeLayerID.value != 'COASTAL_PRIORITIES'){
        loadDataByID('COASTAL_PRIORITIES', version.value)
  }
})

watch(priData, (nv) => {
  if (nv !== null) {
    calculating.value = false
  }
}, { immediate: true })

const hasAnyData = computed(() => {
  const pd = priData.value
  if (!pd) return false
  if (pd['FISH_EST_3CLS']?.some((d: any) => d.value > 0)) return true
  if (pd['FISH_DIA_3CLS']?.some((d: any) => d.value > 0)) return true
  if (pd['SALTMARSH_SPARROW']?.filter((d: any) => d.category !== 'No saltmarsh data').some((d: any) => (d.area ?? 0) > 0)) return true
  if (pd['MIGRATORY_HOTSPOT']?.filter((d: any) => d.category !== 'No data').some((d: any) => (d.area ?? 0) > 0)) return true
  if (pd['HYDROLOGY_COMBINED']?.filter((d: any) => d.category !== 'No data').some((d: any) => (d.area ?? 0) > 0)) return true
  return false
})
</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 .result-pane-header-row{
  border-top: 1px solid white;
}
.pointer{
  cursor: pointer;
}
.bordered{
    border: 1px solid black;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 18px;
    line-height: 1;
    border-radius: 3px;
}
.mapActive{
    background-color: #1D8177;
}
.proj-expander{
    border: 1px solid #989999;
}
</style>